import "bootstrap/dist/css/bootstrap.min.css";
import { memo, useContext, useEffect, useState } from "react";
import { CookiesProvider } from "react-cookie";
import { ThemeProvider, createUseStyles } from "react-jss";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryParamProvider } from "use-query-params";
import { BotContext } from "../src/components/context/BotContext";
import "./App.css";
import { AppRoute } from "./components";
import { BotContextProvider } from "./components/context/BotContext";
import { ProvideAuth, useLocalStorage } from "./core";
import { theme2 } from "./core/theme";

createUseStyles((theme) => ({
  "@global": {
    "#chatwidget": {
      "& *": {
        fontSize: `${theme.messageFontSize}`,
        lineHeight: `calc(${theme.messageFontSize} + 4px)`,
      },
    },
    ".MuiPopover-root *": {
      fontSize: `${theme.messageFontSize}!important`,
    },
    ".MuiPaper-root *": {
      fontSize: `${theme.messageFontSize}!important`,
    },
    a: {
      textDecoration: "underline",
    },
  },
}));

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 1,
    },
  },
});

const Provider = memo(() => {
  const [theme, setTheme] = useState(theme2);
  const { fontSize, setFontSize } = useContext(BotContext);
  const [, setfont] = useLocalStorage("fontSize");
  const { isSaderatCustomization } = JSON.parse(
    sessionStorage.getItem("config")
  );

  useEffect(() => {
    document.title = isSaderatCustomization ? "چت بات صبا" : "چت بات آرتین";
  }, []);

  useEffect(() => {
    if (fontSize) {
      setFontSize(fontSize);
      setfont(fontSize);
      setTheme({ ...theme, messageFontSize: fontSize });
    }
  }, [fontSize]);

  return (
    <ThemeProvider theme={theme}>
      <QueryParamProvider>
        <QueryClientProvider client={queryClient}>
          <ProvideAuth>
            <>
              <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                transition={Zoom}
                theme="colored"
              />
              <AppRoute />
            </>
          </ProvideAuth>
        </QueryClientProvider>
      </QueryParamProvider>
    </ThemeProvider>
  );
});

function App() {
  return (
    <CookiesProvider>
      <BotContextProvider>
        <Provider />
      </BotContextProvider>
    </CookiesProvider>
  );
}

export default App;
